export function fnDrawerMenu(){
  const menuTrigger = document.querySelector('.drawer-menu-trigger');
  const menuClose = document.querySelector('.drawer-menu-close');
  const container = document.querySelector('#drawer-menu');
  const dimmed = document.getElementById('dimmed');

  menuTrigger.addEventListener('click', (event) => {
    let intMove = -100;
    if(window.innerWidth >= 768){
      intMove = -30;
    }
    dimmed.classList.add('on');
    container.style.transform = `translate(` + intMove + `vw)`
    document.body.classList.add('hidden');
  
  }, false);

  menuClose.addEventListener('click', (event) => {
    dimmed.classList.remove('on');

    container.style.transform = `translate(0vw)`
    document.body.classList.remove('hidden');
  }, false);

  const items = document.querySelectorAll(".item > .item-title");
  const itemsExtDown = document.querySelectorAll(".item > .item-title > .item-ext-Down");
  const itemsExtUp = document.querySelectorAll(".item > .item-title > .item-ext-Up");
  const submenus = document.querySelectorAll(".item > .sub-menu");

  items.forEach((el, index) => {
    el.addEventListener('click', () => {
      let intNode = index;
      
      if(el.parentNode.parentNode.classList[0] === "drawer-menu-list"){
        intNode = index + 6;
      }
      
      itemsExtDown.forEach((extMenu, extIndex) => {
        const isActive = extIndex === index;
        
        if(isActive){
          const isStatus = extMenu.classList.contains("on");
          extMenu.classList.toggle("on", !isStatus);
          
        }else{
          extMenu.classList.toggle("on", true)
        }
      });
      
      itemsExtUp.forEach((extMenu, extIndex) => {
        const isActive = extIndex === index;
        
        if(isActive){
          const isStatus = extMenu.classList.contains("on");
          extMenu.classList.toggle("on", !isStatus);
          
        }else{
          extMenu.classList.toggle("on", isActive)
        }
      });

      submenus.forEach((submenu, subIndex) => {
        const isActive = subIndex === intNode;
        
        if(isActive){
          const isStatus = submenu.parentNode.classList.contains("active");
          submenu.parentNode.classList.toggle("active", !isStatus);
        }else{
          submenu.parentNode.classList.toggle("active", isActive);  
        }
      });      
    });
  });

  const topMenu = document.querySelector(".top-menu");
  const topMenuBG = document.querySelector(".top-menu-bg");
  const topItems = document.querySelectorAll(".top-menu > .item.title");
  const topSubmenus = document.querySelectorAll(".top-menu > .item.send-row");
  
  topItems.forEach((el, index) => {
    el.addEventListener('mouseover', () => {
      let intNode = index;
      
      topItems.forEach((elItem, subIndex) => {
        //console.log(subIndex);
        if(subIndex === intNode){
          elItem.classList.toggle("active", true);
        }else{
          elItem.classList.toggle("active", false);
        }
      });

      topSubmenus.forEach((elsub, subIndex) => {
        if(subIndex === intNode){
          elsub.classList.toggle("active", true);
        }else{
          elsub.classList.toggle("active", false);
        }

        elsub.classList.toggle("showDP", true);
        
      });
      
      topMenu.classList.toggle("active", true);
      topMenuBG.classList.toggle("active", true);

    });
  });
  
  topMenu.addEventListener('mouseleave', () => {
    //console.log('mouseleave ');
    topSubmenus.forEach((elsub, subIndex) => {
      elsub.classList.toggle("active", false);
      elsub.classList.toggle("showDP", false);
    });

    topItems.forEach((elItem, subIndex) => {
      elItem.classList.toggle("active", false);
    });

    topMenu.classList.toggle("active", false);
    topMenuBG.classList.toggle("active", false);
  });
  
};
export function fnToggleBanner(){
  const items = document.querySelectorAll('.banner-wrapper > .qc-banner');

  items.forEach((el, index) => {
    el.addEventListener('click', () => {
      let intNode = index;
      
      items.forEach((banner, subIndex) => {
        const isActive = subIndex === intNode;
        
        if(isActive){
          const isStatus = banner.classList.contains("active");
          banner.classList.toggle("active", !isStatus);
        }else{
          banner.classList.toggle("active", isActive);
        }
      });

    });
  });
}

export function fnSelectItem(event){
  //console.log("fnSelectItem");
  //console.log(event);

}

export function setBodyScroll(){
  //console.log("setBodyScroll");
  document.body.classList.remove('hidden');
};

export function goToLocation(url){
  window.location.href = url;
};


export function fn_numberWithCommas(strValue) {

  if(strValue == "" || strValue == undefined){
      return 0;
  }else{
      return strValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");	
  }
  
}

export function fnRemoveChar(event){
  const input = event.target;
  return input.value.replace(/[^0-9]/g, '');
};


export function fnSetTimeTab(){
  
  const tabs = document.querySelectorAll(".tabs > .tab");  
  const tabContents = document.querySelectorAll(".tab-list");  

  tabs.forEach((el, index) => {
    el.addEventListener('click', () => {
      
      tabs.forEach((tab, tabIndex) => {
        tab.classList.toggle("on", tabIndex === index);
      });

      tabContents.forEach((tabContent, tabIndex) => {
        tabContent.classList.toggle("on", tabIndex === index);
      })
    });
  });

}

/*회사 소개*/
export function fnToggleIntroduction(){
  
  const items = document.querySelectorAll('.introduction-img > .img-effect');
  console.log(items);

  items.forEach((el, index) => {
    console.log(index);

    el.addEventListener('click', () => {
      let intNode = index;
      
      items.forEach((itemImg, subIndex) => {
        const isActive = subIndex === intNode;
        
        if(isActive){
          const isStatus = itemImg.classList.contains("active");
          itemImg.classList.toggle("active", !isStatus);
        }else{
          itemImg.classList.toggle("active", isActive);
        }
      });

    });
  });
}